(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    function lbcGetHeaderEl() {
    return document.querySelector('.section-header .header') || document.querySelector('.header');
  }

  function lbcPositionMegaMenu(headerMenuEl) {
    if (!headerMenuEl) return;
    const panel = headerMenuEl.querySelector('.lbc-mega-menu');
    if (!panel) return;
    const headerEl = lbcGetHeaderEl();
    if (!headerEl) return;
    const rect = headerEl.getBoundingClientRect();
    panel.style.top = Math.max(0, Math.round(rect.bottom)) + 'px';
    // Left edge of the panel lines up with the left edge of the header's own
    // content container (the same inset the logo sits at) — mirrors the
    // Ferro Concepts reference where the mega-menu starts under the logo
    // instead of being centered or flush against the browser edge.
    panel.style.left = Math.max(0, Math.round(rect.left)) + 'px';
  }

  function lbcPositionOpenMegaMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      const details = menu.querySelector(':scope > details');
      if (details && details.hasAttribute('open')) {
        lbcPositionMegaMenu(menu);
      }
    });
  }

  function lbcInitHeaderMenuHover() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu.dataset.hoverBound) return;
      menu.dataset.hoverBound = 'true';
      const details = menu.querySelector(':scope > details');
      if (!details) return;
      let closeTimer;
      menu.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        lbcPositionMegaMenu(menu);
        details.setAttribute('open', '');
      });
      menu.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
        }, 150);
      });
    });
  }

  let lbcMegaMenuScrollTicking = false;
  window.addEventListener(
    'scroll',
    () => {
      if (lbcMegaMenuScrollTicking) return;
      lbcMegaMenuScrollTicking = true;
      requestAnimationFrame(() => {
        lbcPositionOpenMegaMenus();
        lbcMegaMenuScrollTicking = false;
      });
    },
    { passive: true }
  );

  window.addEventListener('resize', lbcPositionOpenMegaMenus);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lbcInitHeaderMenuHover);
  } else {
    lbcInitHeaderMenuHover();
  }
  } catch(e) { console.error(e); }
})();

})();
